import { render, staticRenderFns } from "./ScrollUpButton.vue?vue&type=template&id=419945f2&scoped=true&"
import script from "./ScrollUpButton.vue?vue&type=script&lang=js&"
export * from "./ScrollUpButton.vue?vue&type=script&lang=js&"
import style0 from "./ScrollUpButton.vue?vue&type=style&index=0&id=419945f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "419945f2",
  null
  
)

export default component.exports